import { Box } from "@mui/material";
import { AxiosError, AxiosResponse } from "axios";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { getImageById } from "src/utils/api/dashboard";
import { CustomStyles, getStyles } from "src/styles/theme";
import { StylesClasses } from "./styles";
import defaultStyles from "./styles";

type ViewImageProps = {
  label?: string;
  imageId?: string;
  fileUrl?: string;
  customStyles?: CustomStyles<StylesClasses>;
  downloadFileName?: string;
  onDownload?: () => void;
};

const ViewImages = ({
  label = "",
  imageId = "",
  customStyles,
  fileUrl = "",
  downloadFileName,
  onDownload,
}: ViewImageProps) => {
  const defaultSrc = "/assets/images/NoImageFoundIcon.png";
  const styles = getStyles<StylesClasses>(defaultStyles, customStyles);
  const [imageSrc, setImageSrc] = useState("");

  useQuery(["getImage", imageId], () => getImageById(imageId), {
    onSuccess: (res: AxiosResponse) => {
      setImageSrc(res?.data?.fileUrl);
    },
    onError: (err: AxiosError) => {
      setImageSrc(defaultSrc);
    },
    enabled: !!imageId,
    refetchOnMount: true,
  });

  const resolvedUrl = !!imageId ? imageSrc : fileUrl;

  const handleDownload = async () => {
    if (!downloadFileName || !resolvedUrl) return;
    try {
      const response = await fetch(resolvedUrl);
      if (!response.ok) throw new Error("fetch failed");
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(
        new Blob([blob], { type: "application/vnd.google-earth.kml+xml" })
      );
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = downloadFileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(objectUrl), 10000);
    } catch {
      const a = document.createElement("a");
      a.href = resolvedUrl;
      a.download = downloadFileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  const handleClick =
    onDownload ?? (downloadFileName ? handleDownload : undefined);

  const imgEl = (
    <Box
      component="img"
      src={resolvedUrl}
      alt={fileUrl}
      {...styles("img")}
      onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        const target = e.target as HTMLImageElement;
        target.src = "/assets//svg/receipt.svg";
      }}
    />
  );

  return (
    <Box {...styles("wrapper")}>
      {!!label && <Box {...styles("label")}>{label}</Box>}
      {handleClick ? (
        <Box
          sx={{ cursor: "pointer", display: "inline-block" }}
          onClick={handleClick}
        >
          {imgEl}
        </Box>
      ) : (
        <Box component="a" href={resolvedUrl} download target="_blank">
          {imgEl}
        </Box>
      )}
    </Box>
  );
};

export default ViewImages;
